<template>
  <div class="Kanit">
    <div v-if="loading" class="text-center pt-2 pb-4">
      <v-progress-circular
        indeterminate
        color="primary"
        size="60"
        class="mt-3"
      ></v-progress-circular>
    </div>
    <div v-else>
      <div>
        <div class="px-3">จำนวนคิวช่าง : {{ detaildata.amount }}</div>
        <div class="pa-2">
          <div @click="setPosition">
            <v-date-picker
              :events="events"
              :event-color="'red'"
              :allowed-dates="allowedDates"
              @input="show"
              color="primary"
              full-width
              no-title
              v-model="input.appointmentdate"
            ></v-date-picker>
          </div>
        </div>
      </div>

      <div class="text-center mt-6">
        <v-btn
          :loading="updateLoading"
          :disabled="!input.appointmentdate"
          @click="onSaveData"
          large
          rounded
          color="primary"
        >
          บันทึก</v-btn
        >
      </div>
    </div>

    <v-menu
      :close-on-click="false"
      :close-on-content-click="false"
      v-model="showTooltip"
      :position-x="x"
      :position-y="y + 10"
      absolute
      offset-y
    >
      <v-card class="Kanit">
        <div class="pa-2">{{ availableQueue }}</div>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
import api from '@/api'
import axios from 'axios'
import moment from 'moment'
import { mapGetters } from 'vuex'
export default {
  props: {
    isChangeDate: {
      type: Boolean,
      default: false
    },
    orderid: {},
    detaildata: {}
  },
  data() {
    return {
      loading: true,

      updateLoading: false,
      availableQueue: 0,
      x: 0,
      y: 0,
      tempX: 0,
      tempY: 0,
      showTooltip: false,
      appointmentComputed: {},
      tempDate: '',
      input: { appointmentdate: '' },
      events: [],
      appointmentData: [],
      holidays: [],
      queueList: {}
    }
  },
  mounted() {
    this.getHolidays()
    this.getData()
    this.getQuere()
    this.input.appointmentdate = moment(this.detaildata.appointmentdate).format('YYYY-MM-DD')
    this.events = [this.input.appointmentdate]
  },
  computed: {
    pagelength() {
      if (this.total) {
        return Math.ceil(this.total / this.limit)
      } else {
        return 1
      }
    },
    ...mapGetters(['selectedBot']),
    serverUrl() {
      return 'https://api-gpf-hr.zwiz.app/'
    }
  },
  methods: {
    onSaveData() {
      this.updateLoading = true

      var data = {
        pageid: this.selectedBot.pageid,
        orderid: this.detaildata.id,
        appointmentdate: this.input.appointmentdate // YYYY-MM-DD
      }

      api.kingkitchenchangeAppointmentOrderByAdmin(data, (err, response) => {
        this.updateLoading = false
        this.$emit('onsave')
      })
    },
    updateData() {
      this.updateLoading = true
      var data = {
        orderid: this.orderid,
        appointmentdate: moment(this.$store.state.inputCreateOrder.appointmentdate).format(
          'YYYY-MM-DD'
        ) // YYYY-MM-DD
      }
      axios
        .put(this.serverUrl + 'kingkitchen/changeAppointment', data, {
          headers: {
            AUTHORIZATION: 'Bearer xxx xxxx'
          }
        })
        .then(async (response) => {
          if (response.data.responsecode == 200) {
            await this.$store.dispatch('sendMessage', `เปลี่ยนวันนัดสำเร็จ: ${this.orderid}`)
            await this.$swal.fire({
              text: 'สำเร็จ',
              icon: 'success'
            })
          }
          this.updateLoading = false
          this.$emit('onUpdateData', data.appointmentdate)
        })
    },
    nextStep() {
      this.$emit('next')
    },
    changePage(val) {
      var vm = this
      if (this.pagetmp == val) {
        //dont do shit
      } else {
        this.pagetmp = val
        vm.offset = vm.pageNumber * this.limit - this.limit

        this.getData()
      }
    },
    getHolidays() {
      const data = {
        pageid: this.selectedBot.pageid
      }
      api.kingkitchenGetHoliday(data, (err, response) => {
        if (response.responsecode == 200) {
          this.holidays = response.holidays
        }
      })
    },
    getQuere() {
      const data = {
        pageid: this.selectedBot.pageid
      }
      api.kingkitchenGetQueue(data, (err, response) => {
        if (response.responsecode == 200) {
          this.queueList = response.data
        }
      })
    },
    allowedDates(date) {
      let result = true
      let quota = this.queueList[date]
      let availableQueue =
        quota - (this.appointmentComputed[date] ? this.appointmentComputed[date] : 0)
      const diff = moment(new Date()).diff(moment(date), 'days')
      let holidays = this.holidays

      if (
        availableQueue < 1 ||
        availableQueue - this.detaildata.amount < 0 ||
        diff > 15 ||
        holidays.includes(date)
      ) {
        result = false
      }

      return result
    },
    getData() {
      const currentDate = moment().subtract(15, 'day').endOf('day').format('YYYY-MM-DD')
      axios
        .get(this.serverUrl + 'kingkitchen/getAppointmentDateList', {
          params: {
            currentdate: currentDate
          },
          headers: {
            AUTHORIZATION: 'Bearer xxx xxx'
          }
        })
        .then((response) => {
          this.loading = false

          this.appointmentData = response.data.data
          var result = {}
          this.appointmentData.forEach((val) => {
            if (result.hasOwnProperty(moment(val.appointmentdate).format('YYYY-MM-DD'))) {
              result[moment(val.appointmentdate).format('YYYY-MM-DD')] += parseInt(val.count)
            } else {
              Object.assign(result, {
                [moment(val.appointmentdate).format('YYYY-MM-DD')]: parseInt(val.count)
              })
            }
          })

          this.appointmentComputed = result
        })
    },
    setPosition(e) {
      this.showTooltip = false
      this.tempX = e.clientX
      this.tempY = e.clientY
    },
    show(e) {
      setTimeout(() => {
        this.$nextTick(() => {
          this.x = this.tempX
          this.y = this.tempY
          let quota = null

          let allQueueOrder = this.queueList
          if (allQueueOrder) {
            let key = Object.keys(allQueueOrder).find((key) => e.includes(key))
            if (key) {
              quota = allQueueOrder[key]
            }
          }

          if (!quota) {
            let day = moment(e).format('dddd')
            if (['Saturday', 'Sunday'].includes(day)) {
              quota = 8
            } else {
              quota = 10
            }
          }

          const diff = moment(new Date()).diff(moment(e), 'days')
          if (this.appointmentComputed.hasOwnProperty(e)) {
            if (diff > 0) {
              this.availableQueue = `คิวจอง: ${this.appointmentComputed[e]}`
            } else {
              this.availableQueue = `คิวว่าง: ${quota - this.appointmentComputed[e]}`
            }
          } else {
            if (diff > 0) {
              this.availableQueue = `ไม่มีคิวจอง`
            } else {
              this.availableQueue = `คิวว่าง: ${quota}`
            }
          }

          this.showTooltip = true
        })
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/template/kingKitchen/adminMenu/OrderCalendar.vue